module.exports = __webpack_public_path__ + "assets/notFound.64b059544ad3b2cb93224cec69326c04.svg?";